import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { ISalesRep, ISalesRepCallGoal } from './salesRepInterfaces';

export async function deleteSalesRep(sid: string): Promise<IApiExecuteRespone> {
  const response: IApiExecuteRespone = { requestFailed: false };

  try {
    await httpService.delete(ApiUrls.salesReps(sid));
  } catch (error) {
    response.exception = error;
    response.requestFailed = true;
  }

  return response;
}

export async function fetchSalesReps(): Promise<IApiExecuteRespone<ISalesRep[]>> {
  const response: IApiExecuteRespone<ISalesRep[]> = { requestFailed: false };

  try {
    const apiReposne = await httpService.get(ApiUrls.salesReps());
    response.value = await apiReposne.json();
  } catch (error) {
    response.exception = error;
    response.requestFailed = true;
  }

  return response;
}

export async function fetchSalesRepCallGoals(
  sid: string,
  fiscalYear: string
): Promise<IApiExecuteRespone<ISalesRepCallGoal>> {
  const response: IApiExecuteRespone<ISalesRepCallGoal> = { requestFailed: false };

  try {
    const apiReposne = await httpService.get(ApiUrls.salesRepCallGoals(sid, fiscalYear));
    response.value = await apiReposne.json();
  } catch (error) {
    response.exception = error;
    response.requestFailed = true;
  }

  return response;
}

export async function saveSalesRep(rep: ISalesRep): Promise<IApiExecuteRespone<IEntityWithMessages<ISalesRep>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<ISalesRep>> = { requestFailed: false };

  try {
    const apiReposne = await httpService.post(ApiUrls.salesReps(), rep);
    response.value = await apiReposne.json();
  } catch (error) {
    response.exception = error;
    response.requestFailed = true;
  }

  return response;
}

export async function saveSalesRepCallGoals(goals: ISalesRepCallGoal): Promise<IApiExecuteRespone<ISalesRepCallGoal>> {
  const response: IApiExecuteRespone<ISalesRepCallGoal> = { requestFailed: false };

  try {
    const apiReposne = await httpService.post(ApiUrls.salesRepCallGoals(), goals);
    response.value = await apiReposne.json();
  } catch (error) {
    response.exception = error;
    response.requestFailed = true;
  }

  return response;
}
